import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateJourneyStepTraineeSessionMutationVariables = Types.Exact<{
  input: Types.UpdateJourneyStepTraineeSessionInput;
}>;


export type UpdateJourneyStepTraineeSessionMutation = { updateJourneyStepTraineeSession: { sessionId: string } };


export const UpdateJourneyStepTraineeSessionDocument = /*#__PURE__*/ gql`
    mutation updateJourneyStepTraineeSession($input: UpdateJourneyStepTraineeSessionInput!) {
  updateJourneyStepTraineeSession(input: $input) {
    sessionId
  }
}
    `;

export function useUpdateJourneyStepTraineeSessionMutation() {
  return Urql.useMutation<UpdateJourneyStepTraineeSessionMutation, UpdateJourneyStepTraineeSessionMutationVariables>(UpdateJourneyStepTraineeSessionDocument);
};